import { render, staticRenderFns } from "./ChatGPTDevice.vue?vue&type=template&id=8b18c70c&scoped=true&"
import script from "./ChatGPTDevice.vue?vue&type=script&lang=js&"
export * from "./ChatGPTDevice.vue?vue&type=script&lang=js&"
import style0 from "./ChatGPTDevice.vue?vue&type=style&index=0&id=8b18c70c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b18c70c",
  null
  
)

export default component.exports